/**
 * @generated SignedSource<<4b87007eb5360b9c8cca9782cebc59fc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sectionId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "terms"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "sectionId",
    "variableName": "sectionId"
  },
  {
    "kind": "Variable",
    "name": "terms",
    "variableName": "terms"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "question",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "answer",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileTypeIconClassName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PageSectionInformationSearchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "InformationSearchResult",
        "kind": "LinkedField",
        "name": "informationSearch",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "InformationSearchFile",
            "kind": "LinkedField",
            "name": "sources",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PageSectionInformationSearchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "InformationSearchResult",
        "kind": "LinkedField",
        "name": "informationSearch",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "InformationSearchFile",
            "kind": "LinkedField",
            "name": "sources",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "57c8720d81b1a62f0eee58cedc22f80f",
    "id": null,
    "metadata": {},
    "name": "PageSectionInformationSearchQuery",
    "operationKind": "query",
    "text": "query PageSectionInformationSearchQuery(\n  $sectionId: ID!\n  $terms: String!\n) {\n  informationSearch(sectionId: $sectionId, terms: $terms) {\n    question\n    answer\n    sources {\n      name\n      url\n      fileTypeIconClassName\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

node.hash = "932c2f3f8c3b2a9458cc96e791e61f77";

module.exports = node;
